<template>
    <div class="container-loading">
        <div class="body-loading">
            <div class="loading-text">
                <i class="el-icon-loading"></i>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Loading",
}
</script>

<style scoped>
div.container-loading{
    width: 100%;
    height: 100vh;
    position: absolute;
    left: 0;
    top: 0;
    background: transparent;
    z-index: 2000;
}
div.body-loading{
    width: 0.7rem;
    margin: calc((100vh - 0.64rem) / 2) auto auto;
    padding: 0.04rem 0.1rem;
    background: rgba(0,0,0, 0.5);

    font-family: PF-Regular, sans-serif;
    color: #FFFFFF;
    font-size: 0.24rem;
    text-align: center;
    border-radius: 0.05rem;
}
</style>